module.exports = __webpack_public_path__ + "img/sort-alpha-up.a871d61b.svg";